// @ts-nocheck
import React from "react";

export function highlight(text: string, searchValue?: string, highlightStyle?: React.CSSProperties) {
  if (!searchValue) return text;

  highlightStyle = highlightStyle || {color: '#f61111'};

  const index = text.toLowerCase().indexOf(searchValue.toLowerCase());
  const beforeStr = text.substr(0, index);
  const afterStr = text.substr(index + searchValue.length);
  const highlightStr = <span style={highlightStyle}>{text.substr(index, searchValue.length)}</span>;

  return index > -1 ? (
    <span>
      {beforeStr}
      {highlightStr}
      {afterStr}
    </span>
  ) : (
    <span>{text}</span>
  );
}
